export default __webpack_public_path__ + "static/media/ic_glp_arbitrum.9d17c5c3.svg";